import { Autocomplete, LinearProgress, TextField } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import React from 'react'
import { withRouter } from "react-router-dom"
import { withAppContext } from '../context/AppContextProvider'

const styles = (theme) => ({
    loading: {
        margin: theme.spacing(2),
        width: 200,
    },
})

class Picker extends React.Component {
    state = {
        waits: 1,
        remoteUsers: [],
        remoteUser: this.props.remoteUser,
    }

    componentDidMount = async () => {
        await this.getRemoteUsers()

        await this.setState({
            waits: this.state.waits - 1,
        })
    }

    getRemoteUsers = async () => {
        await this.setState({
            waits: this.state.waits + 1,
        })

        try {
            const { remoteUsers } = await this.props.socket.send('remoteUsers', {
                step: 'getRemoteUsers',
            })

            await this.setState({
                remoteUsers,
            })

        } catch (err) {
            this.props.showError(err)
        }

        await this.setState({
            waits: this.state.waits - 1,
        })
    }

    handleChooseRemoteUser = async (event, value) => {
        try {
            const response = await this.props.socket.send('remoteUsers', {
                step: 'setRemoteUser',
                remoteUser: value,
            })

            this.setState({
                remoteUser: value,
            })

            this.props.showMessage(response)

            if (this.props.navigateTo) {
                this.props.history.push(this.props.navigateTo)
            }

        } catch (err) {
            this.props.showError(err)
        }
    }

    renderOption = (props, option, { selected }) => {
        let secondaryText = [
            `(${option.type})`,
        ]

        if (option.email_address) {
            secondaryText.push(option.email_address)
        }

        if (option.mobile_number || option.phone_number) {
            secondaryText.push(option.mobile_number || option.phone_number)
        }

        return (
            <li {...props} key={`${option.type}-${option.id}`}>
                <strong>{option.first_name} {option.last_name}</strong>&nbsp;{secondaryText.join(', ')}
            </li>
        )
    }

    render = () => {
        const { classes, label } = this.props
        const { remoteUsers, remoteUser, waits } = this.state

        return <>
            {waits > 0 &&
                <LinearProgress className={classes.loading} />
            }
            {waits == 0 &&
                <Autocomplete
                    fullWidth
                    renderInput={params => <TextField variant="standard" {...params} label={label || "Choose a Customer"} />}
                    options={remoteUsers}
                    getOptionLabel={option => `${option.first_name} ${option.last_name}`}
                    renderOption={this.renderOption}
                    onChange={this.handleChooseRemoteUser}
                    value={remoteUser || null}
                    isOptionEqualToValue={(option, value) => `${option.type}-${option.id}` == `${value.type}-${value.id}`}
                />
            }
        </>
    }
}

export default withAppContext(withRouter(withStyles(styles, { withTheme: true })(Picker)))
